import {useEffect, useRef, useState} from "react";
import {Body, BodyScroll, Desc, Footer, Images, Logo, Next, Title} from "./style";
import {LogoIcon} from "../../components/Header";
import {useApp} from "../../contexts/app";
import Consent from "./consent";
import Verify from "./verify";
import {ContainerImage} from "../../components/Container";
import {useNavigate} from "react-router-dom";
import {Modal} from "antd";
import CarouselImages from "../../components/Carousel";
import AnonymousChatPopup from "../AnonymoysChat/popup";
import {sleep} from "../../services/app";

export default function Campaign(props: any) {
    const {campaign, customer, T, business, clientCode} = useApp();
    const [step, setStep] = useState("");
    const nextUrlRef = useRef();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const bodyRef = useRef(null);
    const [buttonChatPosition, setButtonChatPosition] = useState(0);

    useEffect(() => {
        calculateButtonPosition()
    }, [campaign?.descriptions]);


    const calculateButtonPosition = () => {
        const bodyHeight = bodyRef?.current?.clientHeight || 0;
        const windowHeight = window.innerHeight || 0;
        if (bodyHeight < (windowHeight - 56 - 120)) {
            setButtonChatPosition(12);
        } else {
            setButtonChatPosition(72);
        }
    }

    const campaignImages = campaign?.imageUrls?.length ? campaign?.imageUrls.map(x => x.url) : []
    return (
        <>
            <ContainerImage style={{height: '100%'}}>
                <Logo>
                    {business?.logoWide || business?.logoUrl || business?.logoFavicon ? (
                        <img src={business?.logoWide || business?.logoUrl || business?.logoFavicon}/>) : (<LogoIcon/>)}
                </Logo>
                <BodyScroll ref={bodyRef}>
                    <Body>
                        {campaign?.showCampaignImage !== false ? (
                            <Images>
                                <CarouselImages height={300}
                                                imageUrls={campaignImages?.length ? campaignImages : ["/assets/images/default_camp.png"]}/>
                            </Images>
                        ) : null}
                        <Title>{campaign?.name}</Title>
                        <Desc dangerouslySetInnerHTML={{__html: campaign?.descriptions}}></Desc>
                        {(!!buttonChatPosition && buttonChatPosition > 12 && campaign?.isOnLiveChat) && (
                            <div style={{height: 56}}></div>)}
                    </Body>
                </BodyScroll>
                <Footer>
                    <Next
                        loading={loading}
                        onClick={() => setStep("verify")}>{campaign?.customButtonText?.trim() || T("Get Started")}</Next>
                </Footer>
                <Modal centered open={step === 'consent'} modalRender={() => (
                    <Consent onClose={event => {
                        setStep("");
                        if (event) {
                            navigate(nextUrlRef.current);
                        }
                    }}/>
                )}/>
                <Modal destroyOnClose centered open={step === 'verify'} modalRender={() => (
                    <Verify onLoading={setLoading} visible={step === 'verify'} onClose={event => {
                        if (event) {
                            nextUrlRef.current = event;
                            if (campaign?.isOffConsentForm) {
                                // force next
                                navigate(nextUrlRef.current);
                            } else {
                                setStep('consent');
                            }
                        } else {
                            setStep("")
                        }
                    }}/>
                )}/>
            </ContainerImage>
            {/* Anonymous chat popup floating button */}
            <AnonymousChatPopup style={buttonChatPosition ? {bottom: buttonChatPosition} : {}} fullButton={true}/>
        </>
    );
}
